import { InputAdornment } from '@mui/material';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';

import { COLOR_CHECKBOX_CUSTOM } from 'constants/ColorVariable';
import { CssTextField, IS_INPUT_SEARCH } from './constant';

function CustomInputYup({
  label,
  maxLength,
  defaultValue,
  name,
  placeholder,
  control,
  register,
  errors,
  useWatch,
  required,
  setValue,
  type,
  setError,
  clearErrors,
  handleSearch,
  onHandelChange,
  multiline,
  rows,
  disabled,
  addErrors,
}) {
  const showError = errors[name];
  // Style for custom input label

  const titleWatch = useWatch({
    control,
    name: name,
  });
  useEffect(() => {
    setValue(name, defaultValue);
    if (defaultValue) {
      clearErrors && clearErrors(name)
    }
    // eslint-disable-next-line
  }, [defaultValue, setValue, name]);

  const handelChange = (e) => {
    setValue(name, e.target.value);
    if (e.target.value) {
      clearErrors && clearErrors(name)
    }
    if (type === IS_INPUT_SEARCH) {
      handleSearch(e.target.value);
    }
    if (e.target.value && onHandelChange) {
      onHandelChange(e);
    }
  };

  return (
    <div>
      <Controller
        render={({ field }) => (
          <CssTextField
            inputProps={{
              maxLength: maxLength,
              style: multiline ? { padding: '0px' } : { padding: '15px' },
            }}
            InputProps={{
              startAdornment: type === IS_INPUT_SEARCH && (
                <InputAdornment position="start">
                  <i className={classNames(`fa fa-search`)} style={{ color: COLOR_CHECKBOX_CUSTOM }} />
                </InputAdornment>
              ),
            }}
            placeholder={type === IS_INPUT_SEARCH ? placeholder : undefined}
            {...register(name)}
            label={<React.Fragment>{placeholder && titleWatch ? placeholder : label}</React.Fragment>}
            variant="outlined"
            required={required}
            error={showError || addErrors ? true : false}
            name={name}
            value={titleWatch || ''}
            onChange={handelChange}
            multiline={multiline ? true : false}
            rows={rows ? rows : 1}
            disabled={disabled || false}
            // CSS
            labelspace={titleWatch === null || titleWatch === '' ? '-1px' : 0}
            heightauto={rows ? 'auto' : '50px'}
          />
        )}
        control={control}
        name={name}
      />
      <p className="error-input error">{showError && errors[`${name}`]?.message}</p>
      <p className="error-input error">{addErrors}</p>
    </div>
  );
}

export default CustomInputYup;
